import { useListInstantiationRequestsQuery } from '../../__generated__/chirp/com/hubspot/automation/templatesrpc/TemplateInstantiationService.hooks';
import { useMemo } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { gate } from 'hub-http/gates';
import { getWorkflowFlowUrl } from '../utils/DetailsPageUrls';
// This hook only supports workflow template usage at the moment, possibly will be used for agents in near future
export function useGetProductUsage({
  appContext,
  productType,
  sourceId,
  skip
}) {
  var _userInfo$gates;
  const {
    userInfo
  } = useDetailsPageContext();
  const sourceIdAsNumber = typeof sourceId === 'string' ? parseInt(sourceId, 10) : sourceId;
  const isUngatedForUnifiedBuilder = userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('Workflows:ModernEditor'));
  const {
    data: templateInstancesData,
    loading: templateInstancesLoading,
    error: templateInstancesError,
    refetch: refetchTemplateInstances
  } = useListInstantiationRequestsQuery({
    variables: {
      templateId: sourceIdAsNumber
    },
    skip: skip || appContext !== 'app' || productType !== 'WORKFLOW_TEMPLATE'
  });
  const parsedTemplateInstances = useMemo(() => {
    var _templateInstancesDat;
    return templateInstancesData === null || templateInstancesData === void 0 || (_templateInstancesDat = templateInstancesData.results) === null || _templateInstancesDat === void 0 ? void 0 : _templateInstancesDat.filter(instance => instance.status === 'COMPLETED').map(instance => ({
      href: getWorkflowFlowUrl(instance.flowId || 0, isUngatedForUnifiedBuilder, instance.targetType),
      createdBy: instance.userId,
      createdAt: instance.createdAt
    }));
  }, [isUngatedForUnifiedBuilder, templateInstancesData === null || templateInstancesData === void 0 ? void 0 : templateInstancesData.results]);
  switch (productType) {
    case 'WORKFLOW_TEMPLATE':
      return {
        usages: parsedTemplateInstances || [],
        loading: templateInstancesLoading,
        error: templateInstancesError,
        refetch: refetchTemplateInstances
      };
    default:
      break;
  }
  return {
    usages: [],
    loading: false,
    error: undefined,
    refetch: undefined
  };
}